export default __webpack_public_path__ + "static/108088-6806da272cd23aa312ed68d4c6adcf49.jpg";